<template>
  <b-container fluid>
    <b-row class="school-container-layout" id="results-student">
      <b-col cols="12" class="results-student-content-table">
        <b-row class="results-student-content-report">
          <table-grid
            :data="gridData"
            :columns="gridColumns"
            :filter-key="searchQuery"
            :content="content"
          ></table-grid>
        </b-row>
      </b-col>
      <b-col cols="12" class="mt-5 mb-5 results-student-content-table">
        <b-row>
          <b-col cols="12" style="text-align: center">
            <span>
                   <span @click="download()">
              <img :src="srcImagen('xls.png')" class="results-xls-img" alt />
              <a class="results-dowload" >DESCARGAR RESULTADOS DE TODOS LOS ESTUDIANTES</a>
                   </span>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
        <ModalSend :content="contentMsj" v-if="activeModalSend"/>
  </b-container>
</template>
<script>
import ModalSend from "@/components/Global/ModalSendReturn";

import TableGrid from "@/components/Global/Table";
    import {mapState} from 'vuex'
    import XLSX from "xlsx";

export default {
  name: "ResultsStudent",
  components: {
    TableGrid,
    ModalSend
  },

  data: () => ({
    search: "",
    searchQuery: "",
    gridColumns: [
      {
        key: "nombre",
        name: "Estudiante",
        width: "3",
        width_th: "3",
        class: "table-td-align-left",
        class_text: "table-text-td"
      },
      {
        key: "correo",
        name: "Correo",
        width: "2",
        width_th: "2",
        class: "table-td-align-center",
        class_text: "table-text-td"
      },
      {
        key: "dni",
        name: "DNI",
        width: "1",
        width_th: "1",
        class: "table-td-align-center",
        class_text: "table-text-td"
      },
      {
        key: "celular",
        name: "Celular",
        width: "2",
        width_th: "2",
        class: "table-td-align-center",
        class_text: "table-text-td"
      },
      {
        key: "carrera",
        name: "Carrera",
        width: "2",
        width_th: "2",
        class: "table-td-align-center",
        class_text: "table-text-td"
      },
      {
        key: "boton",
        name: "Resultados",
        width: "2",
        width_th: "2",
        class: "table-td-align-center-botton-report",
        class_text: "table-text-td"
      }
    ],
    gridData: [],
    content: {
      url: "/admin/resultados-estudiante",
      button: "RESULTADOS"
    },
       contentError: {
                title: 'Disculpe',
                msj: 'La opcion seleccionada no tiene informacion',
                button: 'Aceptar',
                icon: 2,
                back: 'reportes'
            },
            contentMsj: {}
  }),
  created() {
    this.$store.dispatch("setModulo", "RESULTADOS POR ESTUDIANTE");
    this.$store.dispatch("setNav", 'active');
    this.$store
      .dispatch("getEstudiantesStatus", localStorage.getItem("keys"))
      .then(response => {
        this.gridData = response.data;
           if (this.gridData.length === 0) {
                        this.contentMsj = this.contentError
                        this.$store.dispatch('setActiveModalSend', true)
                        
                    } else {
                        this.$store.dispatch('setActiveModalSend', false)
                    }
      })
      .catch(error => {
        console.log("error: getEstudiantesStatus ->" + error.message);
      });
  },
  methods: {
                download() {
                let worksheet_name = "Listado Estudiantes por Estado";
                let workbook = XLSX.utils.book_new();
                let new_list = this.gridData.map(function (obj) {
                    return {
                        nombre: obj.nombre,
                        dni: obj.dni,
                        celular: obj.celular,
                        Correo: obj.correo,
                        Grado: obj.grado,
                        Seccion: obj.seccion,
                        Carrera: obj.carrera,
                        Estado: obj.estado,
                    };
                });
                let data = XLSX.utils.json_to_sheet(new_list);
//                /*ubicar celda*/
//
//                var first_sheet_name = workbook.SheetNames[0];
//                var address_of_cell = 'A1';
//                var worksheet = workbook.Sheets[first_sheet_name];
//                var desired_cell = worksheet[address_of_cell];
                /*estable el ancho automatico*/
//                const data = XLSX.utils.aoa_to_sheet(new_list);
//                data['!cols'] = fitToColumn(new_list);

//                function fitToColumn(arrayOfArray) {
//                    // get maximum character of each column
//                    return arrayOfArray[0].map((a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => a2[i].toString().length)) }));
//                }
                /*para darle formato*/
//                data['A1'].s = {
//                    fill: {
//                        patternType: "none", // none / solid
//                        fgColor: {rgb: "FF000000"},
//                        bgColor: {rgb: "FFFFFFFF"}
//                    },
//                    font: {
//                        name: 'Times New Roman',
//                        sz: 16,
//                        color: {rgb: "#FF000000"},
//                        bold: true,
//                        italic: false,
//                        underline: false
//                    },
//                    border: {
//                        top: {style: "thin", color: {auto: 1}},
//                        right: {style: "thin", color: {auto: 1}},
//                        bottom: {style: "thin", color: {auto: 1}},
//                        left: {style: "thin", color: {auto: 1}}
//                    }
//                };
                  XLSX.utils.book_append_sheet(workbook, data, worksheet_name);
                  XLSX.writeFile(workbook, `${worksheet_name}.xlsx`);

                this.$store.dispatch('setActiveModal', true)
            },
    goRouter(url) {
      this.$router.push(url);
    },
    srcImagen(img) {
      let src = require("@/assets/images/" + img);
      return src;
    }
  },
  computed: {
    ...mapState(["activeModalSend"])
  }
};
</script>